import { action, makeObservable, runInAction } from "mobx";
import { ITooltipViewModel, TooltipTypeEnum } from "../tooltip-base/tooltip-view-model.interface";
import { ITooltipModel } from "../tooltip-base/tooltip-model.interface";
import { IRegularTooltipsContainer } from "./regular-tooltips-container.interface";
import { TooltipBaseService } from "../tooltip-base.service";
import { RegularTooltipModel } from "./regular-tooltip.model";
import { IRegularTooltipsService } from "./regular-tooltips.service.interface";
import { IRegularTooltipOptions } from "./regular-tooltip-options.interface";
import { IServiceFactoryExtended } from "../../service-factory-extended.interface";
import { IBubbleTooltipOptions } from "./bubble-tooltip-options.interface";

export class RegularTooltipsService extends TooltipBaseService implements IRegularTooltipsService, IRegularTooltipsContainer {

    constructor(services: IServiceFactoryExtended) {
        super(services);
        makeObservable(this);
    }

    removeTooltip(tooltip: ITooltipModel): void {
        const index = this.toolTips.findIndex(t => t.id === tooltip.id);
        if (index >= 0) {
            runInAction(() => {
                this.toolTips.splice(index, 1);
            });
        }
    }

    protected _setDefaultTooltipOptions(options: IRegularTooltipOptions): IRegularTooltipOptions {
        options = {
            showOverlay: true,
            showCloseButton: false,
            closeOnClickOutside: true,
            animated: true,
            ...options
        };

        return options;
    }

    showBubbleTooltip(options: IBubbleTooltipOptions): ITooltipViewModel {
        const bubbleTooltipBaseOptions = {
            tooltipType: TooltipTypeEnum.Bubble,
            closeOnClickOutside: true,
            closeOnScroll: true,
            hasGlow: false,
            showOverlay: false,
            ...options
        }

        const bubbleTooltip = this.showTooltip(bubbleTooltipBaseOptions);
        return bubbleTooltip;
    }

    @action.bound
    showTooltip(options: IRegularTooltipOptions): ITooltipViewModel {
        options = this._setDefaultTooltipOptions(options);
        const tooltipModel = new RegularTooltipModel(this, this.services, options);
        this.toolTips.push(tooltipModel);
        return tooltipModel;

    }
}
